import Image from 'next/image';
import ThermoDefaultImg from '@/assets/images/cart/Thermo Fisher Scientific.svg';
import { useState, useEffect } from 'react';
import clsx from 'clsx';

interface IProps {
  width?: number;
  height: number;
  src: string;
  className?: string;
  bordered?: boolean;
  onClick?: () => void;
  alt?: string;
}

function ProductImage({ width, height, src, className, bordered, onClick, alt = 'Product Image' }: IProps) {
  const [imgSrc, setImgSrc] = useState<string>();
  useEffect(() => {
    setImgSrc(src);
  }, [src]);
  const baseClass = `object-contain rounded-md ${bordered === false ? '' : 'border border-solid border-[#E5E5E5]'}`;

  const onImageLoadError = (e) => {
    setImgSrc(ThermoDefaultImg);
  };

  const imageClsx = clsx(baseClass, className);

  return (
    <Image
      src={imgSrc || ThermoDefaultImg}
      width={width}
      height={height}
      alt={alt}
      onError={onImageLoadError}
      className={imageClsx}
      onClick={onClick}
    />
  );
}

export { ProductImage };
